import {shoppingBagSvg as Icon__small__shoppingBagSvg} from '../Icon__small/Icon__small--shoppingBag.js'

export var shoppingBag = {
  name: 'shoppingBag',
  category: 'icon',
  colorable: true,
  svg: Icon__small__shoppingBagSvg,
};
